import { render, staticRenderFns } from "./EndorsementHistory.vue?vue&type=template&id=e3c5c5be"
import script from "./EndorsementHistory.vue?vue&type=script&lang=js"
export * from "./EndorsementHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports